import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ButtonAutoplayDesktop } from "./ButtonAutoplayDesktop.component";
import { ButtonAutoplayMobile } from "./ButtonAutoplayMobile.component";

interface ButtonAutoplay {
  duration:number,
  hideCountDownButton:() => void,
  playbackStatus:string,
  startNextVideo:() => void,
  onEndAction?:() => void
}

export function ButtonAutoplay(props:ButtonAutoplay){
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return isMobile ?
    <ButtonAutoplayMobile { ...props }/> :
    <ButtonAutoplayDesktop { ...props }/>;
}
